var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8617 8C13.8617 8.48902 13.468 8.88272 12.9831 8.87858H9.75891L6.82895 13.5657L5.65613 13.5698L7.12733 8.88272L3.89484 8.88272L3.02041 10.0555L2.1377 10.0514L2.72617 8.00415L2.1377 5.94861L3.02456 5.94033L3.90728 7.12972L7.1149 7.12972L5.65613 2.43018L6.82895 2.43432L9.75891 7.12143L12.9831 7.12143C13.4555 7.11314 13.87 7.52756 13.8617 8Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlight);
export default __webpack_public_path__ + "static/media/icon_flight.bbbe4b889fb6321b2ae0ae7b2cb5df76.svg";
export { ForwardRef as ReactComponent };